export default __webpack_public_path__ + "77507c3fa83381532646d597251fca75.svg";